import Hammer from "hammerjs";

export default class DeskpadNavigation {
  //https://stackoverflow.com/a/4819886
  isTouchDevice() {
    var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
    var mq = function(query) {
      return window.matchMedia(query).matches;
    };
    if (
      "ontouchstart" in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)
    ) {
      return true;
    }
    var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join(
      ""
    );
    return mq(query);
  }

  initMouseEvents() {
    const canvas = this.canvas;
    canvas.on("mouse:wheel", function(opt) {
      if (!opt.e.altKey) {
        return;
      }
      //different browser has different scroll speed, solution was takken from here https://stackoverflow.com/a/24595588
      function normalizeWheelSpeed(event) {
        var normalized;
        if (event.wheelDelta) {
          normalized =
            (event.wheelDelta % 120) - 0 === -0
              ? event.wheelDelta / 120
              : event.wheelDelta / 12;
        } else {
          var rawAmmount = event.deltaY ? event.deltaY : event.detail;
          normalized = -(rawAmmount % 3 ? rawAmmount * 10 : rawAmmount / 3);
        }
        return normalized;
      }
      // let delta = opt.e.deltaY;
      let delta = normalizeWheelSpeed(opt.e) * 5;

      let zoom = this.getZoom();
      zoom = zoom + delta / 200;
      if (zoom > 5) zoom = 5;
      if (zoom < 0.05) zoom = 0.05;
      this.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
      this.fire("canvas:viewport");
      this.fire("canvas:zoom");
      opt.e.preventDefault();
      opt.e.stopPropagation();
    });
    canvas.on("mouse:down", function(opt) {
      if (this.getActiveObject()) {
        return;
      }
      let evt = opt.e;
      if (evt.altKey === true) {
        this.isDragging = true;
        this.selection = false;
        this.lastPosX = evt.clientX;
        this.lastPosY = evt.clientY;
      }
    });
    canvas.on("mouse:move", function(opt) {
      if (this.isDragging) {
        let e = opt.e;
        let vpTran = this.viewportTransform.slice(0);
        vpTran[4] += e.clientX - this.lastPosX;
        vpTran[5] += e.clientY - this.lastPosY;
        this.setViewportTransform(vpTran);
        this.requestRenderAll();
        this.lastPosX = e.clientX;
        this.lastPosY = e.clientY;
        this.fire("canvas:viewport");
      }
    });
    canvas.on("mouse:up", function(opt) {
      this.isDragging = false;
      this.selection = true;
    });

    canvas.on("mouse:down", function(opt) {
      this.touchLastX = opt.e.clientX;
      this.touchLastY = opt.e.clientY;
    });
  }

  initTouchEvents() {
    const canvas = this.canvas;
    const canvasElement = document.querySelector("canvas.upper-canvas");
    const mc = new Hammer(canvasElement);

    mc.get("pan").set({ direction: Hammer.DIRECTION_ALL, pointers: 2 });
    mc.get("pinch").set({ enable: true });

    mc.on("pan", function(ev) {});

    let initialZoom = canvas.getZoom();
    let initialPanX = canvas.viewportTransform[4];
    let initialPanY = canvas.viewportTransform[5];

    mc.on("pinchstart", function(ev) {
      initialZoom = canvas.getZoom();
      initialPanX = canvas.viewportTransform[4];
      initialPanY = canvas.viewportTransform[5];
    });

    mc.on("pinchmove", function(ev) {
      canvas.setZoom(initialZoom * ev.scale);
      canvas.viewportTransform[4] = initialPanX + ev.deltaX;
      canvas.viewportTransform[5] = initialPanY + ev.deltaY;
      canvas.requestRenderAll();
      canvas.fire("canvas:zoom");
      canvas.fire("canvas:viewport");
    });
    mc.on("pinchend pinchcancel", function(ev) {});
  }

  //TODO: add proprety which says that Navigation was already initialized on this canvas instance
  constructor(canvas) {
    this.canvas = canvas;

    canvas.zoomIn = _ => {
      let zoom = canvas.getZoom();
      zoom = zoom + 0.05;
      if (zoom > 5) zoom = 5;
      if (zoom < 0.05) zoom = 0.05;
      canvas.zoomToPoint({ x: canvas.cutW / 2, y: canvas.cutH / 2 }, zoom);
      canvas.fire("canvas:zoom");
      canvas.fire("canvas:viewport");
    };

    canvas.zoomOut = _ => {
      let zoom = canvas.getZoom();
      zoom = zoom - 0.05;
      if (zoom > 5) zoom = 5;
      if (zoom < 0.05) zoom = 0.05;
      canvas.zoomToPoint({ x: canvas.cutW / 2, y: canvas.cutH / 2 }, zoom);
      canvas.fire("canvas:zoom");
      canvas.fire("canvas:viewport");
    };

    if (this.isTouchDevice()) {
      this.initTouchEvents();
    } else {
      this.initMouseEvents();
    }
  }
}
